import React, { useEffect, useState } from 'react'
import { authAxios } from '../config/config';
import IsLoadingHOC from "./IsLoadingHOC";
import { saveUser } from '../Redux/Reducers/authSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

function Settings({setLoading}) {
  const navigate = useNavigate();

    const dispatch = useDispatch()
    const [data, setdata] = useState({
        fname : "",
        lname : "",
        email: "",
        
      });
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setdata((prev) => ({
          ...prev,
          [name]: value,
        }));
      };
    

      const getUserDetail = async () => {
        setLoading(true);
        await authAxios()
          .get(`/auth/userdetail`)
          .then((response) => {
            setLoading(false);
            const resData = response?.data;
            setdata(prevValues => ({
                ...prevValues,
                ...resData?.data 
              }));
            })
          .catch((error) => {
            setLoading(false);
            console.log(error);
          });
      };
      const EditUserDetail = async () => {
        setLoading(true);
        await authAxios()
          .post(`/auth/editUserDetail`,data)
          .then((response) => {
            setLoading(false);
            const resData = response?.data;
            dispatch(saveUser(resData?.data));
            toast.success(resData?.message);
            getUserDetail()
            navigate(`/`);
            })
          .catch((error) => {
            setLoading(false);
            toast.error("somthing went wrong");
            console.log(error);
          });
      };

useEffect(() => {
    getUserDetail()
}, [])


console.log(data,"datadata")
  return (
   
    <>
    <div className="flex shadow-lg flex-1 flex-col justify-center px-5 py-6 rounded-[20px] lg:px-5 bg-white border max-w-[400px] mx-auto absolute w-[95%] top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%]">

    <div>
      <label
        htmlFor="fname"
        className="block text-sm font-medium leading-6 text-gray-900 mt-2"
      >
        First Name
      </label>
      <div className="mt-2">
        <input
          id="fname"
          name="fname"
          type="text"
          value={data.fname}
          onChange={handleChange}
          required
          className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
    </div>
    <div>
      <label
        htmlFor="lname"
        className="block text-sm font-medium leading-6 text-gray-900 mt-2"
      >
        Last Name
      </label>
      <div className="mt-2">
        <input
          id="lname"
          name="lname"
          type="text"
          value={data.lname}
          onChange={handleChange}
          required
          className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
    </div>
    <div>
      <label
        htmlFor="email"
        className="block text-sm font-medium leading-6 text-gray-900 mt-2"
      >
        Email address
      </label>
      <div className="mt-2">
        <input
          id="email"
          name="email"
          type="email"
          value={data.email}
          onChange={handleChange}
          required
          disabled
          className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>
      <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-black px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm mt-5"
              onClick={EditUserDetail}
          >
              Save Change 
            </button>
    </div>
    </div>
</>
    
  )
}

export default IsLoadingHOC(Settings)